import styled from "styled-components";

export const LoginContainer = styled.div`
    width: 100%;
    max-width: 452px;
    margin-right: auto;
    margin-left: auto;
    position: relative;
    transition: transform 0.8s;
    padding: 20px;

    @media screen and (min-width: 768px) {
        padding: 0;
    }

    .kuda-auth--layout {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: flex-start;
        margin-top: 134px;

        .page-heading-title {
            margin-bottom: 48px;
        }

        .auth-container {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;

            .flex {
                display: -ms-flexbox !important;
                display: flex !important;
            }

            .align-start {
                -ms-flex-align: start !important;
                align-items: flex-start !important;
            }

            .justify-between {
                -ms-flex-pack: justify !important;
                justify-content: space-between !important;
            }

            .auth-layout-wrap {
                width: 100%;
            }

            .kuda-auth--wrap {
                max-width: 440px;
                width: 100%;
                margin-right: auto;

                .kuda-login--wrap {
                    .auth-wrap {
                        background: var(--whiteAlt);
                        border: 1px solid var(--borderOff);
                        box-shadow: 15px 30px 40px var(--boxShadow);
                        border-radius: 5px;
                        padding: 35px 51px 49px;
                        border: 1px solid green;
                    }
                }

                .kuda-announcement--card {
                    background: #dfe3ff;
                    border: 1px solid rgba(219, 220, 224, 0.5);
                    box-shadow: 15px 30px 40px rgba(64, 25, 109, 0.07);
                    border-radius: 5px;
                    padding: 16px 20px;
                    margin-bottom: 18px;

                    &.animated {
                        -webkit-animation-duration: 0.8s;
                        animation-duration: 0.8s;
                        -webkit-animation-fill-mode: both;
                        animation-fill-mode: both;
                        position: relative;
                    }

                    &.kudaFadeInUp {
                        -webkit-animation-name: kudaFadeInUp;
                        animation-name: kudaFadeInUp;
                    }
                    p {
                        color: #000000;
                        font-size: 1rem !important;
                        line-height: 1.4;

                        .kuda-external--link {
                            display: flex;
                            align-items: center;

                            svg {
                                height: 14px;
                                width: auto;
                                position: relative;
                                transform: translateY(-0.5px);
                                margin-left: 5px;
                            }
                        }
                    }
                }

                @media only screen and (max-width: 575px) {
                    max-width: 100%;
                }
            }
        }
    }
`;
